/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseMetricsResponseData } from './genericApiResponseMetricsResponseData';
import type { GenericApiResponseMetricsResponseMessage } from './genericApiResponseMetricsResponseMessage';
import type { GenericApiResponseMetricsResponsePagination } from './genericApiResponseMetricsResponsePagination';
import type { GenericApiResponseMetricsResponseError } from './genericApiResponseMetricsResponseError';

export interface GenericApiResponseMetricsResponse {
  data?: GenericApiResponseMetricsResponseData;
  message?: GenericApiResponseMetricsResponseMessage;
  pagination?: GenericApiResponseMetricsResponsePagination;
  error?: GenericApiResponseMetricsResponseError;
  statusCode?: number;
}
